module.exports = __webpack_public_path__ + "static/media/521SunsetAveNW_2018-06-06_53.7af8f851.jpg";